<template>
        <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border py-5">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td colspan="3">
                    
                    <div :style="{ backgroundImage: 'url(' + layout + ')' }" class="background-container">
                      <div class="banner-img"><span v-html="bannercontent"></span></div>
                      <div class="profile-logo"><img :src="myyaaklogo" /></div>
                      <div class="profile-name"></div>
                   </div>
                    </td>  
                </tr>
                
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
  </template>
<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Myyaaktemplate',
    props:[
       'bannerposition',
       'bannercontent',
    ],
    components: {
        },
    data: () => ({
      headersection : require("@/assets/myyaak/headersection.png"),
      leftsection : require("@/assets/myyaak/leftsection.png"),
      middlesection:  require("@/assets/myyaak/middlesection.png"),
      rightsection :  require("@/assets/myyaak/rightsection.png"),
      adhere: require("@/assets/506.jpg"),
      layout: require("@/assets/myyaak/myyaak.png"),
     }),
      mounted() {
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
#addadvertiser .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px !important;}
.padding-top-0{padding-top: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggablecontent{height: 124px;}
.list-item {
  width:100%;
  height: 100%;
  position: relative;
}
.h5{background-color: hsl(240deg 19% 82%);font-size:18px;}
.header-content{width:100%;height: 71px;}
.left-content{height: 100%; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
#bannercontentimage{width:100%;height:100%;position: relative;}
#bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.avatarcls{width: 79%;height: 70%; margin-top: 19%;}
.postionsection{width: 100%;height: 100%;}
.background-container{width: 100%;
  position: relative;
  background-size: contain;
  height: 600px;
  background-position: center;
}

</style>
<style>
.banner-img span img.list-item {
  width: 63%;
  position: absolute;
  top: 33%;
  height: auto;
  left: 20%;
}
.myvideo{
      top: 35%;
    display: block;
    position: absolute;
    left: 8%;
}
</style>